import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { DivBackgroundOpacity, ListLinkContainer } from "@utils/extra-style";
import "@utils/extra-style.scss";

const QuoteId = (props) => {
  const { t, id, name, isActive, siteId } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={isActive !== 5 ? 1 : "0.2"}>
        <ListLinkContainer>
          <Link
            className="listing__link-info"
            to={`/site/view/${siteId}/quote-view-${id}`}
          >
            {id + "-" + name}
          </Link>
        </ListLinkContainer>
      </DivBackgroundOpacity>
    </>
  );
};

QuoteId.defaultProps = {};

QuoteId.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
};

export default withTranslation()(QuoteId);
